import { render, staticRenderFns } from "./DeliveriesIndex.vue?vue&type=template&id=5e44d90b&scoped=true"
import script from "./DeliveriesIndex.vue?vue&type=script&lang=js"
export * from "./DeliveriesIndex.vue?vue&type=script&lang=js"
import style0 from "./DeliveriesIndex.vue?vue&type=style&index=0&id=5e44d90b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e44d90b",
  null
  
)

export default component.exports